import {QueryClient, useQuery} from "react-query";
import {fetchTicketOperations} from "../api/easeedesk/apis";

const searchOperations = async (ticketId, options) => {
    const {response, error} = await fetchTicketOperations(ticketId, options);

    return response ? response.data.data : response;
};

export default function useTicketOperations(ticketId, options) {
    return useQuery([
        'ticket_operations',
        {ticketId, options}
    ], () => searchOperations(ticketId, options), {refetchOnWindowFocus: false});
}
